import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { memo } from 'react';

import ButtonSwitcher from 'common/shared-ui/src/components/ButtonSwitcher';
import WarningModal from 'common/shared-ui/src/components/WarningModal';

import { useTranslation } from '../../../../packages/common/utils/getLocalString';
import DateSwitcher from '../DateSwitcher';

const SpreadsheetHeader = ({
  pageTitle,
  isWarningModalOpen,
  handleToggleWarningModal,
  closeWarningModal,
  warningModalType,
  timeType,
  timeTypes,
  handleChangeTimeType,
  startOfWeek,
  endOfWeek,
  handleToggleWeek,
  handleUpdateSpreadsheet,
  getReadOnlyIssues,
  tableSum,
}) => {
  const getLocalString = useTranslation();
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('lg'),
  );
  return (
    <Grid
      container
      wrap='nowrap'
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 5,
      }}
    >
      <Grid
        container
        sx={{
          alignItems: 'center',
        }}
      >
        <WarningModal
          isWarningModalOpen={isWarningModalOpen}
          handleToggle={handleToggleWarningModal}
          closeWarningModal={closeWarningModal}
          type={warningModalType}
          title={getLocalString('messages', 'saveChanges')}
        />
        <Grid
          size={'grow'}
          container
          wrap='nowrap'
          direction={isSmallScreen ? 'column' : 'row'}
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {isSmallScreen ? (
            <Grid
              container
              wrap='nowrap'
              sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant='h1'>{pageTitle}</Typography>
              <Typography variant='h4'>
                {getLocalString('SpreadsheetContainer', 'labels', 'weekSum')}
                {getLocalString('labels', 'hour')}
              </Typography>
            </Grid>
          ) : (
            <Typography variant='h1'>{pageTitle}</Typography>
          )}
          <Grid
            container
            sx={{
              justifyContent: isSmallScreen ? 'space-between' : 'auto',
              marginTop: isSmallScreen ? 3 : 'auto',
            }}
          >
            <Box
              sx={{
                marginLeft: !isSmallScreen ? 8 : 'auto',
              }}
            >
              <ButtonSwitcher
                selectedButtonIndex={timeType === timeTypes.MAIN_HOURS ? 0 : 1}
                handleChangeFunc={handleChangeTimeType}
                values={{
                  firstButton: timeTypes.MAIN_HOURS,
                  firstButtonText: () =>
                    getLocalString(
                      'SpreadsheetContainer',
                      'labels',
                      'timeMain',
                    ),
                  secondButton: timeTypes.OVER_HOURS,
                  secondButtonText: () =>
                    getLocalString(
                      'SpreadsheetContainer',
                      'labels',
                      'timeOver',
                    ),
                }}
              />
            </Box>
            <Box
              sx={{
                marginLeft: !isSmallScreen ? 5 : 'auto',
              }}
            >
              <DateSwitcher
                dateFrom={startOfWeek}
                dateTo={endOfWeek}
                handleToggle={handleToggleWeek}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {!isSmallScreen && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              marginRight: 0.5,
            }}
          >
            <Button
              disableRipple
              onClick={handleUpdateSpreadsheet}
              variant='cutBluePrimary'
            >
              {getLocalString('buttons', 'save')}
            </Button>
          </Box>
          <Button
            disableRipple
            variant='cutGreySecondary'
            onClick={getReadOnlyIssues}
          >
            <Typography variant='h5'>
              {getLocalString('buttons', 'clear')}
            </Typography>
          </Button>
        </Box>
      )}
    </Grid>
  );
};

export default memo(SpreadsheetHeader);
